var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":['both','passenger','captain'],"label":"Filter"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('data-table',{attrs:{"url":"debug_view","initial-url-search-params":_vm.params,"enable-delete":false,"enable-add":false,"enable-edit":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }